<template>
  <div class="tahun-ajaran-list-page">
    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
      <div slot="header" class="row align-items-center">
        <div class="col-lg-6">
          <h6 class="text-uppercase ls-1 mb-1">Setting Tahun Ajaran</h6>
        </div>
        <div class="col-lg-6 text-lg-right">
          <b-button variant="primary" size="sm" @click="showFormModal(null)"><i class="fa fa-user-plus" aria-hidden="true"></i> Tambah Data</b-button>
        </div>
      </div>
      <div class="text-center text-muted">
        <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
          <div class="p-2">
            <b-row>
              <b-col lg="1" class="my-1" style="width: 100px">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
              </b-col>
              <b-col lg="7" class="my-1"> </b-col>
              <b-col lg="4" class="my-1">
                <b-input-group size="sm">
                  <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Cari"></b-form-input>

                  <b-input-group-append>
                    <b-button variant="primary" style="border-radius: 0px !important" :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table
              :items="tahunAjaranList"
              :fields="fields"
              :busy="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              responsive="sm"
              show-empty
              small
              @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo" /><br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(name)="row">
                <div class="my-2 list-murid text-center">
                  <label>{{ row.item.name }}</label>
                </div>
              </template>
              <template #cell(start_date)="row">
                <div class="my-2 list-murid text-center">
                  <label>{{ row.item.start_date == "1970-01-01" ? "-" : row.item.start_date }}</label>
                </div>
              </template>
              <template #cell(is_current)="row">
                <div class="my-2 list-murid text-center">
                  <label>{{ row.item.is_current == "1" ? "Ya" : "Tidak" }}</label>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="my-2">
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Ubah" class="icon-clicked p-1" @click="showFormModal(row.item)"><i class="fa fa-edit" aria-hidden="true"></i></a>
                  <a v-if="row.item.is_show == '1'" href="javascript:void(0)" v-b-tooltip.hover title="Hapus" class="icon-clicked p-1" @click="confirmDeleteTahunAjaran(row.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-lg-end justify-content-center py-2">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </card>
    <b-modal ref="tahun-ajaran-form-modal" class="tahun-ajaran-form-modal" size="md" :title="setTitle" @show="resetForm" @hidden="resetForm" hide-footer no-close-on-backdrop>
      <tahun-ajaran-form :id="id" :detail="detail"></tahun-ajaran-form>
    </b-modal>
  </div>
</template>
<style scoped>
.foto-field {
  height: 50px;
}
</style>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import TahunAjaranForm from "../../../components/Main/TahunAjaran/TahunAjaranForm";
// import SquareLoader from 'vue-spinner/src/SquareLoader.vue'

export default {
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  components: {
    TahunAjaranForm,
    // SquareLoader
  },
  data() {
    return {
      setTitle: "",
      id: null,
      detail: {},
      isBusy: false,
      showLoader: false,
      items: [],
      fields: [
        { key: "name", label: "Nama", sortable: true, class: "text-center" },
        { key: "start_date", label: "Tanggal Mulai Pembelajaran", sortable: true, class: "text-center" },
        { key: "is_current", label: "Sedang Berjalan ?", sortable: true, class: "text-center", thStyle: { width: "10px" } },
        { key: "actions", label: "Aksi", class: "action-field", thStyle: { width: "10px" } },
      ],
      filter_form: {
        userId: null,
        startDate: null,
        endDate: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 400, 800, 1000],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      tahunAjaranList: "getTahunAjaranList",
      token: "getToken",
    }),
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showFormModal(param) {
      if (param) {
        this.id = param.id;
        this.detail = param;
        this.setTitle = "Edit Data";
      } else {
        this.detail = {};
        this.id = null;
        this.setTitle = "Tambah Data";
      }
      this.$refs["tahun-ajaran-form-modal"].show();
    },
    hideFormModal() {
      this.$refs["tahun-ajaran-form-modal"].hide();
      this.resetForm();
    },
    resetForm() {
      EventBus.$emit("resetForm", true);
    },
    async confirmDeleteTahunAjaran(userId) {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.deleteTahunAjaran(userId);
          }
        });
    },
    async deleteTahunAjaran(id) {
      await this.$store
        .dispatch("deleteTahunAjaran", { id })
        .then((res) => {
          this.getTahunAjaranList();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getTahunAjaranList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getTahunAjaranList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  mounted() {
    this.totalRows = this.tahunAjaranList.length;
  },
  async created() {
    await this.getTahunAjaranList();
    EventBus.$on("hideFormModal", (val) => {
      if (val) {
        this.hideFormModal();
      }
    });
  },
};
</script>
<style lang="css" scoped>
.line-with-icon svg {
  /* color: #adb7be; */
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1rem;
}
.line-with-icon {
  position: relative;
  padding: 0 0 0 1.75em;
  margin: 0 0 1em;
}
.user-article a {
  color: black;
}
.class-list > .line-with-icon > a {
  color: #ca062a;
}
.user-article a:hover {
  color: #ca062a;
}

.btn-open-answer {
  color: #6c757d;
}
.btn-open-answer:hover {
  color: #ca062a;
}
</style>
